import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IOpportunityMSServiceNote } from '~/types/note/models'

export const {
  getNoteListData: getOpportunityMSServiceNoteListData,
  getNoteDataById: getOpportunityMSServiceNoteDataById,
  getNoteListDataByParentId: getOpportunityMSServiceNoteListDataByOMSSId,
} = makeNoteMockData<IOpportunityMSServiceNote>({
  entityName: 'opportunityMSService',
  storageKeyPrefix: 'opportunitymsservice',
})
